import { filterOnlyHavingValueEqualTo, filterOnlyHavingValueFromArray } from './byParameterName.js';
import PitchData from '../enums/PitchData.js';
import ResultData from '../enums/ResultData.js';
import PitchReprocessed from '../enums/PitchReprocessed.js';
import PitchResultCombined from '../enums/PitchResultCombined.js';
import EnumValueProvider from '../providers/EnumValueProvider.js';
import ScoringData from '../enums/ScoringData.js';

const filterOnlyMatchingTo = function(parameterPath, value){
    const isArray = value instanceof Array;
    if (isArray) {
        // TODO - maybe check lenght here as well ?
        return filterOnlyHavingValueFromArray(parameterPath, value);
    }

    return filterOnlyHavingValueEqualTo(parameterPath, value);
};

const filterNewScoringData = function(resultData, expectedPair) {
    return (
        (
            !expectedPair.pitchCall
            || resultData[ScoringData.PitchCall.key] === expectedPair.pitchCall
        )
        && (
            !expectedPair.plateAppearanceResult
            || resultData[ScoringData.PlateAppearanceResult.key] === expectedPair.plateAppearanceResult
        )
    );
};

const filterPitchResultOrPitchCallAndPlateAppearance = function(resultData, expectedPitchResults, expectedPitchCallsAndPaResults) {
    // new scoring goes here (preferred over BBH)
    if (typeof(resultData[ScoringData.PlateAppearanceResult.key]) === 'string') {
        // check PitchResultCombined description for more info
        return expectedPitchCallsAndPaResults.some(filterNewScoringData.bind(this, resultData));
    }

    // BBH data goes here...
    if (typeof(resultData[PitchData.Result.key]) === 'string') {
        return expectedPitchResults.includes(resultData[PitchData.Result.key]);
    }

    return false;
};

const filterOnlyMatchingPitchResult = function(pitchResults) {
    const expectedPitchResults = [];
    const expectedPitchCallsAndPaResults = [];

    for (const combinedKey of pitchResults) {
        let combinedValue = null;
        if (combinedKey && combinedKey.indexOf('-') === -1) {
            // fallback for filtering only by pitch result, not the most elegant way to do it, but will work as an intermediate solution
            combinedValue = Object.values(PitchResultCombined).find(cv => cv && cv.pitchResult === combinedKey);
        }
        else {
            combinedValue = EnumValueProvider.getValue(combinedKey, PitchResultCombined);
        }

        if (!combinedValue) {
            // TODO - throw ?
            continue;
        }

        if (combinedValue.pitchResult) {
            expectedPitchResults.push(combinedValue.pitchResult);
        }
        // TODO - pitch call AND/OR pa result should always be set
        if (combinedValue.pitchCall || combinedValue.plateAppearanceResult) {
            expectedPitchCallsAndPaResults.push({
                pitchCall: combinedValue.pitchCall,
                plateAppearanceResult: combinedValue.plateAppearanceResult
            });
        }
    }

    return [
        // check if there is such property in Data set
        { parameter: [ResultData.Data.key], operator: 'defined', value: true },
        // check if value is not empty
        { parameter: [ResultData.Data.key], operator: 'function', value: function (resultData) {
            return filterPitchResultOrPitchCallAndPlateAppearance(
                resultData, expectedPitchResults, expectedPitchCallsAndPaResults
            );
        } }
    ];
};

const filterOnlyMatchingPitchSet = function(pitchSetKey){
    let parameterPath = ResultData.getDataPath(PitchData.Mechanics.key);
    return filterOnlyMatchingTo(parameterPath, pitchSetKey);
};

const filterOnlyMatchingPitchType = function(pitchTypeKey){
    let parameterPath = ResultData.getDataPath(PitchData.Classification.key);
    return filterOnlyMatchingTo(parameterPath, pitchTypeKey);
};

const filterOnlyMatchingTagId = function(tagId){
    let parameterPath = [ResultData.TagId.key];
    return filterOnlyMatchingTo(parameterPath, tagId);
};

const filterOnlyMatchingBatterTagId = function(batterId){
    let parameterPath = [ResultData.BatterTagId.key];
    return filterOnlyMatchingTo(parameterPath, batterId);
};

const filterOnlyMatchingBatterHandedness = function(handedness){
    let parameterPath = ResultData.getDataPath(PitchData.SwingHandedness.key);
    return filterOnlyMatchingTo(parameterPath, handedness);
};

const filterOnlyMatchingPitcherHandedness = function(handedness){
    let parameterPath = ResultData.getDataPath(PitchData.Handedness.key);
    return filterOnlyMatchingTo(parameterPath, handedness);
};

const filterOnlyMatchingStrikeZoneSectors = function(sectors){
    let parameterPath = ResultData.getDataPath(PitchReprocessed.StrikeZonePositionR.key);
    return filterOnlyMatchingTo(parameterPath, sectors);
};

const filterOnlyMatchingNumberOfOuts = function(outs){
    let parameterPath = ResultData.getDataPath(PitchData.BeforePlayOuts.key);
    return filterOnlyMatchingTo(parameterPath, outs);
};

const filterOnlyMatchingNumberOfBalls = function(balls){
    let parameterPath = ResultData.getDataPath(PitchData.BeforePlayBalls.key);
    return filterOnlyMatchingTo(parameterPath, balls);
};

const filterOnlyMatchingNumberOfStrikes = function(strikes){
    let parameterPath = ResultData.getDataPath(PitchData.BeforePlayStrikes.key);
    return filterOnlyMatchingTo(parameterPath, strikes);
};

const filterOnlyMatchingRunnersOn = function(runnersOn){
    let parameterPath = ResultData.getDataPath(PitchData.BeforePlayRunnersOn.key);
    return filterOnlyMatchingTo(parameterPath, runnersOn);
};

export {
    filterOnlyMatchingTo, filterOnlyMatchingPitchResult, filterOnlyMatchingPitchSet,
    filterOnlyMatchingPitchType, filterOnlyMatchingTagId, filterOnlyMatchingBatterTagId,
    filterOnlyMatchingBatterHandedness, filterOnlyMatchingPitcherHandedness,
    filterOnlyMatchingStrikeZoneSectors,
    // scoring context
    filterOnlyMatchingNumberOfOuts, filterOnlyMatchingNumberOfBalls,
    filterOnlyMatchingNumberOfStrikes, filterOnlyMatchingRunnersOn,
};